class Footer {
	constructor() {
		this.footerMain = document.querySelector(".footer-main");
		const lastBlock = document.querySelector("main >:last-child");
		if (!lastBlock || !lastBlock.classList.contains("block-dark")) {
			this.footerMain.classList.add("footer-dark");
			const button = this.footerMain.querySelector(".btn.btn-grey");
			button.classList.remove("btn-grey");
			button.classList.add("btn-black");
		}
	}
}
